import ColFormItemWrapper from "../CustomForm/ColWFormItemWrapper";
import { Button, Col, DatePicker, Input, Modal, Row, Form } from "antd";
import dayjs, {
  dateCustomFormat,
  generalFormatAntd,
} from "../../../utils/dayjs";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { TimePicker } from "antd";
import { daysJsFormat } from "../../../utils/constants";
import "./CustomDateTimePicker.css";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";

export const CustomDateTimePicker = ({
  item,
  index,
  refForm,
  disabled,
  onValuesChange,
}) => {
  const [dateTime, setDateTime] = useState(moment());

  const inputRef = useRef(null); // Reference for the input container

  const { isMobile } = useDeviceDetect();

  useEffect(() => {
    let initValue = "";

    if (typeof item.value === "string" || item.value instanceof String) {
      initValue = dayjs(item.value);
    } else {
      initValue = item.value;
    }

    setDateTime(initValue);
  }, []);

  const triggerOnSelect = (value, p) => {
    console.log(value);
    refForm.current.setFieldsValue({ [item.name]: value });
    item?.onChange(value);

    setDateTime(value);
  };

  const timePickerOnChange = e => {
    console.log(e);
    refForm.current.setFieldsValue({ [item.name]: e });
    item?.onChange(e);
    setDateTime(e);
  };

  const getPickerContainer = () => {
    if (isMobile) {
      return () => document.getElementById("time-picker-modal");
    }
    return () => document.body;
  };

  const handleFocus = id => {
    const element = document.getElementById(id);
    const elementRect = element.getBoundingClientRect();
    const offsetY =
      window.scrollY + elementRect.top - window.innerHeight * 0.25;
    window.scrollTo({
      top: offsetY,
      behavior: "smooth",
    });
  };

  return (
    <Col span={item.col}>
      <div id="time-picker-container">
        <Row ref={inputRef}>
          <ColFormItemWrapper
            item={{ ...item, col: 16 }}
            index={index}
            refForm={refForm}
          >
            <DatePicker
              //locale={frFR}
              onClick={() => handleFocus("time-picker-container")}
              value={dateTime}
              suffixIcon={item.suffixIcon}
              addonAfter={item.addonAfter}
              disabledDate={item?.disabledDate ? item.disabledDate : null}
              disabledTime={
                item?.disabledDateTime ? item.disabledDateTime : null
              }
              format={dateCustomFormat}
              onChange={triggerOnSelect}
              onFocus={() => handleFocus("time-picker-container")}
              onValueChange={triggerOnSelect}
              onCalendarChange={triggerOnSelect}
              allowClear={
                item.allowClear !== undefined ? item.allowClear : false
              }
              style={{ width: "100%" }}
              disabled={item.disabled || disabled}
            />
          </ColFormItemWrapper>
          <ColFormItemWrapper
            item={{ ...item, col: 8, label: "" }}
            index={index}
            refForm={refForm}
          >
            <TimePicker
              key={item.name + "time-picker"}
              onFocus={() => handleFocus("time-picker-container")}
              style={{ width: "100%" }}
              popupClassName={"customTimePicker"}
              format={daysJsFormat.hour}
              allowClear={false}
              showOk={false}
              onMouseUp={() => handleFocus("time-picker-container")}
              onOpenChange={() => handleFocus("time-picker-container")}
              needConfirm={false}
              changeOnScroll={true}
              disabledDate={item?.disabledDate ? item.disabledDate : null}
              disabledTime={
                item?.disabledDateTime ? item.disabledDateTime : null
              }
              onChange={timePickerOnChange}
              onSelect={timePickerOnChange}
              onValueChange={timePickerOnChange}
              value={dateTime}
            />
          </ColFormItemWrapper>

          {/*{isMobile && (*/}
          {/*  <>*/}
          {/*    <Col span={6}>*/}
          {/*      <Form.Item label={""}>*/}
          {/*        <Input*/}
          {/*          style={{ width: "100%", marginTop: 40 }}*/}
          {/*          value={dateTime.format(daysJsFormat.hour)}*/}
          {/*          onClick={() => {*/}
          {/*            setPickerModalVisible(true);*/}
          {/*          }}*/}
          {/*          suffix={<ClockCircleOutlined />}*/}
          {/*        ></Input>*/}
          {/*      </Form.Item>*/}
          {/*    </Col>*/}
          {/*    <ColFormItemWrapper*/}
          {/*      item={{ ...item, col: 6, label: "" }}*/}
          {/*      index={index}*/}
          {/*      refForm={refForm}*/}
          {/*    >*/}
          {/*      <Modal*/}
          {/*        key={"modal-inpout-full"}*/}
          {/*        open={isPickerModalVisible}*/}
          {/*        destroyOnClose={true}*/}
          {/*        onCancel={() => setPickerModalVisible(false)}*/}
          {/*        footer={null}*/}
          {/*        width={190}*/}
          {/*        title={"Heure de fin"}*/}
          {/*        className="time-picker-modal"*/}
          {/*      >*/}
          {/*        <TimePicker*/}
          {/*          open={isPickerModalVisible}*/}
          {/*          style={{ width: "100%" }}*/}
          {/*          popupClassName={"customTimePicker"}*/}
          {/*          format={daysJsFormat.hour}*/}
          {/*          allowClear={false}*/}
          {/*          showOk={false}*/}
          {/*          needConfirm={false}*/}
          {/*          changeOnScroll={true}*/}
          {/*          onChange={timePickerOnChange}*/}
          {/*          onSelect={timePickerOnChange}*/}
          {/*          onValueChange={timePickerOnChange}*/}
          {/*          value={dateTime}*/}
          {/*          getPopupContainer={getPickerContainer()}*/}
          {/*        />*/}
          {/*      </Modal>*/}
          {/*    </ColFormItemWrapper>*/}
          {/*  </>*/}
          {/*)}*/}
        </Row>
      </div>
    </Col>
  );
};
